export const minimumHeight = 700;

export const scrollSpeed = 500;